import analytic from '@/scripts/libs/analytic';
import { BranchLinkOptions } from './branchLinkConfiguration';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export interface PerformanceTracker {
  trackGenerationDone($hasGenerationError?: boolean): void;
  trackLinkOpen(destination: string, options?: BranchLinkOptions): void;
}

export const startTrackerTimer = (): PerformanceTracker => {
  const creationTimestamp = Date.now();
  let timeInMillisecondTakenToGenerate = -1;
  let hasGenerationError = true;

  return {
    trackGenerationDone($hasGenerationError = false): void {
      timeInMillisecondTakenToGenerate = Date.now() - creationTimestamp;
      hasGenerationError = $hasGenerationError;
    },

    trackLinkOpen(destination: string, options?: BranchLinkOptions): void {
      const payload = {
        destination,
        timeTaken: timeInMillisecondTakenToGenerate,
        timeElapsed: Date.now() - creationTimestamp,
        error: hasGenerationError,
        options,
      };
      analytic.send({
        category: 'performance',
        action: 'open:branch-link-button',
        property: JSON.stringify(payload),
        label: hasGenerationError ? 'error' : undefined,
        value: timeInMillisecondTakenToGenerate,
      });
    },
  };
};
